export default __webpack_public_path__ + "static/media/IsuranceDefault.68913ae0.png";